<template>
  <div class="why-pokemon-data">
    <div class="content has-text-left">
      <div class="columns">
        <div class="column is-8">
          <h1 class="title">Do we need another Pokédex site?</h1>
          <p class="subtitle">(probably not)</p>
          <p>
            I needed a simple Pokémon effectiveness/stats/evolutions kind of website that would assist me through several Pokémon games that I have bought lately. Specifically, I wanted to get info with only using one hand on the keyboard, while still holding the 3DS on the other. (the phone was not an option for me)
          </p>
          <p>
            Granted, there's a lot of pokédex fan sites out there and by no means is this site trying to undermine them / steal traffic from them. In my opinion is too late for that. Most of those sites have years of work on their back that cannot be topped by a simple iteration of the pokédex; with an updated UI. Which is what this site aims to be.
          </p>
          <br>
          <div class="box">
            <figure class="image">
              <img src="/images/my-pokemon-games.jpg">
              <figcaption>Yup, I need a new mousepad.</figcaption>
            </figure>
          </div>
          <p>
            I hope you find some use for this site too. If it fills a gap, good.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Why Pokémon data',
  data() {
    return {
      modal: {
        pkg: false,
      },
    }
  },
}
</script>
